








































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import CtrlResetBtn from '@/components/common/control/CtrlResetBtn.vue';
import CtrlClearBtn from '@/components/common/control/CtrlClearBtn.vue';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import CtrlDatePickerMonth from '@/components/common/control/CtrlDatePickerMonth.vue';
import CtrlHimmoku from '@/components/common/search/CtrlHimmoku.vue';
import G_070_HambaiYosokuConfirm_Table from '@/components/G_kaigai/G_070_HambaiYosokuConfirm_Table.vue';
import {
  Flg,
  SumiFlg,
  UmuFlg,
  OutStatus,
  HimmokuShuruiPtn,
  TaishoFlg,
} from '@/constants/constants';
import {
  dateStrToNum,
  downloadCSVToSjis
} from '@/utils/utils';
import Vue from 'vue';
import moment from 'moment';
import { mapGetters } from 'vuex';

// CSVヘッダ
const csvHeaderCom = [
  "年月(自)",
  "年月(至)",
  "品目コード",
  "品目名",
];

// CSV明細データ取得
function getCsvValue(i : number, data: any) {
  let val = "";
  let colNo;

  if (i % 2 != 0) { // 奇数(C/S)
    colNo = i;
  } else {          // 偶数(t)
    colNo = i - 1;
  }
  if (data["dataCnt" + colNo] !== 0)
  {// 販売予測データが存在する
    val = data["val" + i];
  }

  return val;
}

export default Vue.extend<any, any, any, any>({
  name: 'N_Ham030_HambaiYosokuConfirm',
  components: {
    CtrlResetBtn,
    CtrlClearBtn,
    CtrlNormalBtn,
    CtrlMessageDialog,
    CtrlDatePickerMonth,
    CtrlHimmoku,
    G_070_HambaiYosokuConfirm_Table,
  },
  data: () => ({
    UmuFlg,
    Flg,
    SumiFlg,
    HimmokuShuruiPtn,
    TaishoFlg,

    kyoryokuKojoCd: 0,

    // 初期値
    nengetsuFDef: 0,    // 年月(自)
    nengetsuTDef: 0,    // 年月(至)
    headerTitleDef: [], // 一覧タイトル

    nengetsuF: 0,
    nengetsuT: 0,
    himmokuCd: 0,

    searchStr: '',            // 検索フィルタ
    joken: null,              // 再読込時の条件
    headerTitle: [] as any,   // 一覧タイトル
    selectedItems: [],        // 選択一覧

    showMessageDialog: false,
    messageID: '',
    messageTextParam: [] as any,

    showCheckMessageDialog: false,
    checkMessageID: '',
    checkMessageTextParam: [] as any,
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
    items() {
      if (this.$store.state['g070'].list == null) {
        return [];
      } else {
        return this.$store.state['g070'].list;
      }
    },
  },
  methods: {
    //----------------------------------------
    // 一覧チェック行設定
    //----------------------------------------
    setSelectedItems(items: any) {
      this.selectedItems = items;
    },
    //----------------------------------------
    // 品目変更
    //----------------------------------------
    handleCallbackOkHimmoku(item: any) {
      if (item && item.himmokuCd) {
        this.himmokuCd = item.himmokuCd;
      } else {
        this.himmokuCd = 0;
      }
    },
    //----------------------------------------
    // クリア
    //----------------------------------------
    handleClear() {
      // 一覧クリア
      this.$refs['refTable'].uncheckAllCheckBoxs();
      this.$store.dispatch('g070/resetData');
      this.selectedItems = [];
      this.headerTitle = this.headerTitleDef;

      // 検索条件クリア
      this.nengetsuF = this.nengetsuFDef;
      this.nengetsuT = this.nengetsuTDef;
      this.himmokuCd = 0;
      this.searchStr = '';
    },
    //----------------------------------------
    // 再読込
    //----------------------------------------
    async handleReset() {
      // 一覧取得
      this.getList();
    },
    //----------------------------------------
    // ワーニングメッセージ[OK]
    //----------------------------------------
    handleMessageDialogOk() {
      if (this.messageID == 'KI_W123') {
        window.location.href = '/';
      }
      else if (this.messageID == 'KI_W107') {
        this.handleReset();
      }
      this.messageID = '';
      this.messageTextParam = [];
      this.showMessageDialog = false;
    },
    //----------------------------------------
    // 確認メッセージ[キャンセル]
    //----------------------------------------
    handleCheckMessageDialogCancel() {
      this.showCheckMessageDialog = false;
    },
    //----------------------------------------
    // CSVダウンロードアイコン押下
    //----------------------------------------
    handleExportCsv() {
      const rows = [];  // CSV行
      
      // ヘッダ行
      let header = [];
      header.push(...csvHeaderCom);
      header.push(...this.headerTitle);
      rows.push(header);

      // 明細行
      this.selectedItems.forEach((item: any) => { // 選択行分繰り返し
        // 共通・一覧情報セット
        let details = [];
        details.push(
          this.joken.nengetsuF,
          this.joken.nengetsuT,
          item.himmokuCd,
          item.himmokuMei,
        );

        // 一覧情報セット
        for (let i = 1; i <= 48; i++) {
          details.push(
            getCsvValue(i, item),
          );
        }
        rows.push(details);
      });
      
      // ファイル名
      let fileAddStr = '';
      fileAddStr += '_' + this.joken.nengetsuF.toString() + '-' + this.joken.nengetsuT.toString();
      fileAddStr += '_' + moment(new Date()).format('YYYYMMDD_HHmmss');
      
      const fileName = `販売予測確認${fileAddStr}.csv`;

      // CSVダウンロード
      downloadCSVToSjis(rows, fileName);
    },
    //----------------------------------------
    // 初期値セット
    //----------------------------------------
    async initValues() {
      // 協力工場セット
      this.kyoryokuKojoCd = this.userInfo.shiiresakiCd;

      // 年月取得
      await this.getNengetsu();
    
      // 初期値セット
      this.nengetsuF = this.nengetsuFDef; 
      this.nengetsuT = this.nengetsuTDef; 
    },
    //----------------------------------------
    // 年月取得
    //----------------------------------------
    async getNengetsu() {
      // パラメータ
      const params = {
        kyoryokuKojoCd: this.kyoryokuKojoCd,
        genzaiYmd: this.userInfo.onlineData.genzaiYmd,
      };
      // 年月取得
      const res = await this.$store.dispatch(
        'g070/getNengetsu',
        params
      );

      // 結果判定
      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.messageID &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        this.showMessageDialog = true;
        this.messageID = res.data.error.messageID;
        this.messageTextParam = res.data.error.messageArgs;
        return;
      }
      
      // 初期値を退避
      this.nengetsuFDef = res.data.responseData.nengetsuF; 
      this.nengetsuTDef = res.data.responseData.nengetsuT;
      this.headerTitleDef = Object.values(res.data.responseData.title);

      // 一覧タイトルをセット
      this.headerTitle = this.headerTitleDef;
    },
    //----------------------------------------
    // 一覧取得
    //----------------------------------------
    async getList() {
      await new Promise((resolve) => setTimeout(resolve, 300));

      // validate
      this.$refs.form.validate();

      // 入力チェック
      if (!this.nengetsuF || !this.nengetsuT) {
        this.showMessageDialog = true;
        this.messageID = 'KI_W100';
        this.messageTextParam = ['年月'];
        return;
      }
      if (dateStrToNum(this.nengetsuF) > dateStrToNum(this.nengetsuT)) {
        this.showMessageDialog = true;
        this.messageID = 'KI_W101';
        this.messageTextParam = ['年月'];
        return;
      }

      // 月数を取得
      const datF = moment(dateStrToNum(this.nengetsuF), 'YYYYMM').toDate();
      const datT = moment(dateStrToNum(this.nengetsuT), 'YYYYMM').toDate();
      const monthF = datF.getFullYear() * 12 + datF.getMonth();
      const monthT = datT.getFullYear() * 12 + datT.getMonth();
      const  tsukisu = monthT - monthF + 1;

      if (tsukisu > 12) {
        this.showMessageDialog = true;
        this.messageID = 'KI_W112';
        this.messageTextParam = ['年月が12ヶ月を超える','読込','\n年月を変更'];
        return;
      }

      // validateエラーの場合「入力内容に誤りがあります」を表示
      if (!this.$refs.form.validate()) {
        this.showMessageDialog = true;
        this.messageID = 'KI_W121';
        this.messageTextParam = [];
        return;
      }

      // 一覧クリア
      this.$refs['refTable'].uncheckAllCheckBoxs();
      this.$store.dispatch('g070/resetData');

      // パラメータ
      const params = {
        kyoryokuKojoCd: this.kyoryokuKojoCd,
        nengetsuF: dateStrToNum(this.nengetsuF),
        nengetsuT: dateStrToNum(this.nengetsuT),
        himmokuCd: this.himmokuCd,
      };

      // 一覧取得
      const res = await this.$store.dispatch(
        'g070/getList',
        params
      );

      // 結果判定
      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.messageID &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        this.showMessageDialog = true;
        this.messageID = res.data.error.messageID;
        this.messageTextParam = res.data.error.messageArgs;
        return;
      }

      // 一覧タイトルセット
      this.headerTitle = res.data.responseData.title;

      // 条件退避
      this.joken = res.data.responseData.joken;
    },
  },
  created() {
    if (!this.userInfo.shiiresakiCd) {
      this.showMessageDialog = true;
      this.messageID = 'KI_W123';
      this.messageTextParam = ['利用者マスタの仕入先が未設定の', '実行'];
      return;
    }
    this.initValues();
  },
  beforeDestroy() {
    this.$store.dispatch('g070/resetData');
  },
});
